<template>
    <SectionTitleWithSubTitle v-if="indexPage"
                :title="'ISTORIJSKI PREGLED CENA'"
                classes="section-title mb-4"
            />
    <div class="shadow rounded bg-white overflow-hidden mt-3" :class="{ 'chart-card-xl': indexPage }">
        <!-- =================================================
            HEADER GRAFIKA
        ================================================== -->
        <BContainer fluid class="container-pages" v-if="indexPage">
            <BRow> 
                <BCol xl="12"  class="text-left">
                     
<div class="chart-header text-start">
       
            <div>
                <NuxtLink
         :to="`/cene-istorija/cene-stoke-na-pijacama/cene-jagnjadi-na-pijacama/cacak`">
           
        
                <h2 class="chart-title text-start">
                    Prosečne mesečne
                    {{ productName }}
                    - {{ cityName }}
                </h2>
                </NuxtLink>
                <div class="chart-subtitle">
                    <template v-if="sortedPrices.length">
                        Period:
                        {{ firstPeriod }}
                        –
                        {{ lastPeriod }}
                        <span class="chart-separator">
                            •
                        </span>
                        Prosečne mesečne cene
                    </template>
                </div>
            </div>
        </div>
                </BCol>  
                <BCol xl="12">
<div   >
             
    <div class="history-category-nav ps-lg-4 ps-md-4 ps-sm-3  ps-3 mt-2">

    <p class="history-category-nav-title fw-bold  ">
        Izaberi kategoriju:
    </p>

    <div class="history-category-nav-items  ">

        <NuxtLink
            v-for="item in categories"
            :key="item.id"
            :to="`/cene-istorija/${item.title_path}`"
            class="history-category-nav-item"
             
        >
            {{ item.name }}
        </NuxtLink>

    </div>

</div>
        </div>
                </BCol>          
            </BRow>
               
        </BContainer>
        <div class="chart-header" v-if="!indexPage">
            <div>
                <h2 class="chart-title">
                    Prosečne mesečne
                    {{ productName }}
                    - {{ cityName }}
                </h2>
                <div class="chart-subtitle">
                    <template v-if="sortedPrices.length">
                        Period:
                        {{ firstPeriod }}
                        –
                        {{ lastPeriod }}
                        <span class="chart-separator">
                            •
                        </span>
                        Prosečne mesečne cene
                    </template>
                </div>
            </div>
        </div>
        <div class="shadow rounded p-element-page bg-white mb-3" v-if="!indexPage">
            <p class="history-description mb-0"  >
                {{ description }}
            </p>
     
        </div>
        
        <!-- =================================================
            STATISTIKA
        ================================================== -->
        <div
            v-if="sortedPrices.length"
            class="chart-stats"
        >
            <!-- samo od xl (desni stub na pocetnoj): poslednja cena i promena u odnosu na prosle godine -->
            <div v-if="indexPage" class="chart-xl-extra chart-xl-hero">
                <span class="chart-xl-hero-label">Poslednja cena, {{ lastPeriod }}</span>
                <strong class="chart-xl-hero-value">
                    {{ formatPrice(lastPrice) }}
                    <small>din.</small>
                </strong>
                <span
                    v-if="yearChange !== null"
                    class="chart-xl-hero-change"
                    :class="{ 'is-down': yearChange < 0 }"
                >
                    {{ yearChange > 0 ? '+' : '' }}{{ formatPrice(yearChange) }}% u odnosu na prošlu godinu
                </span>
            </div>

            <!-- PROSEK -->
            <div class="chart-stat chart-stat-average">
                <div class="chart-stat-icon stat-average">
                    <svg class="chart-stat-svg" aria-hidden="true" :viewBox="`0 0 ${statIcons.average.w} ${statIcons.average.h}`"><path :d="statIcons.average.d" fill="currentColor" /></svg>
                </div>
                <div>
                    <span class="chart-stat-label">
                        Prosečna cena
                    </span>
                    <strong class="chart-stat-value">
                        {{ formatPrice(averagePrice) }}
                        <small>din.</small>
                    </strong>
                    <span class="chart-stat-period">
                        {{ averagePeriod }}
                    </span>
                </div>
            </div>
            <!-- NAJVIŠA -->
            <div class="chart-stat chart-stat-max">
                <div class="chart-stat-icon stat-max">
                    <svg class="chart-stat-svg" aria-hidden="true" :viewBox="`0 0 ${statIcons.max.w} ${statIcons.max.h}`"><path :d="statIcons.max.d" fill="currentColor" /></svg>
                </div>
                <div>
                    <span class="chart-stat-label">
                        Najviša cena
                    </span>
                    <strong class="chart-stat-value">
                        {{ formatPrice(maxPrice) }}
                        <small>din.</small>
                    </strong>
                    <span class="chart-stat-period">
                        {{ maxPricePeriod }}
                    </span>
                </div>
            </div>
            <!-- NAJNIŽA -->
            <div class="chart-stat chart-stat-min">
                <div class="chart-stat-icon stat-min">
                    <svg class="chart-stat-svg" aria-hidden="true" :viewBox="`0 0 ${statIcons.min.w} ${statIcons.min.h}`"><path :d="statIcons.min.d" fill="currentColor" /></svg>
                </div>
                <div>
                    <span class="chart-stat-label">
                        Najniža cena
                    </span>
                    <strong class="chart-stat-value">
                        {{ formatPrice(minPrice) }}
                        <small>din.</small>
                    </strong>
                    <span class="chart-stat-period">
                        {{ minPricePeriod }}
                    </span>
                </div>
            </div>
            <!-- BROJ MESECI -->
            <div class="chart-stat chart-stat-count">
                <div class="chart-stat-icon stat-count">
                    <svg class="chart-stat-svg" aria-hidden="true" :viewBox="`0 0 ${statIcons.count.w} ${statIcons.count.h}`"><path :d="statIcons.count.d" fill="currentColor" /></svg>
                </div>
                <div>
                    <span class="chart-stat-label">
                        Broj meseci
                    </span>
                    <strong class="chart-stat-value">
                        {{ sortedPrices.length }}
                    </strong>
                </div>
            </div>

            <!-- samo od xl (desni stub na pocetnoj): promena u odnosu na isti mesec prosle godine i veza ka istoriji -->
            <template v-if="indexPage">
                <NuxtLink to="/cene-istorija/cene-stoke-na-pijacama" class="chart-xl-extra chart-xl-cta">
                    Pogledaj istoriju cena stoke
                    <i class="esei icon-angle-right-solid" aria-hidden="true"></i>
                </NuxtLink>

                <!-- od xl izbor kategorije je u desnom stubu ispod veze ka istoriji (gore je tada sakriven) -->
                <div class="chart-xl-extra chart-xl-cats">
                    <p class="history-category-nav-title fw-bold">
                        Izaberi kategoriju:
                    </p>

                    <div class="history-category-nav-items">
                        <NuxtLink
                            v-for="item in categories"
                            :key="`xl-${item.id}`"
                            :to="`/cene-istorija/${item.title_path}`"
                            class="history-category-nav-item"
                        >
                            {{ item.name }}
                        </NuxtLink>
                    </div>
                </div>
            </template>
        </div>
        <!-- =================================================
            NASLOV IZNAD GRAFIKA
        ================================================== -->
        <div
            v-if="sortedPrices.length"
            class="chart-graph-title"
        >

            <span>

            </span>
        </div>
        <!-- =================================================
            LINE GRAFIK
        ================================================== -->
        <div
            v-if="sortedPrices.length"
            class="line-chart-wrapper"
        >
            <!-- Y OSA -->
            <div class="line-y-axis">
                <span
                    v-for="value in yAxisValues"
                    :key="value"
                >
                    {{ formatPrice(value) }}
                </span>
            </div>
            <!-- SCROLL -->
            <div class="line-chart-scroll">
                <!-- grafik je jedan SVG (iscrtava se na serveru; cene i meseci su tekst u HTML-u) -->
                <svg
                    class="lc-svg"
                    role="img"
                    :width="chartWidth"
                    :height="svgHeight"
                    :viewBox="`0 0 ${chartWidth} ${svgHeight}`"
                    :aria-label="`Prosečne mesečne cene: ${productName} - ${cityName}`"
                    @pointermove="onPointer"
                    @pointerdown="onPointer"
                    @pointerleave="hoverIndex = null"
                >
                    <!-- HORIZONTALNE GRID LINIJE -->
                    <g class="lc-grid">
                        <line
                            v-for="(value, i) in yAxisValues"
                            :key="`grid-${value}`"
                            x1="0"
                            :x2="chartWidth"
                            :y1="gridY(i)"
                            :y2="gridY(i)"
                        />
                    </g>
                    <!-- VERTIKALNE GRID LINIJE -->
                    <path class="lc-vgrid" :d="verticalGridPath" />
                    <!-- LINIJA -->
                    <polyline class="lc-line" :points="linePoints" />
                    <!-- TACKE: isti put nacrtan tri puta (plavi prsten, beli razmak, plava sredina) -->
                    <path class="lc-dot lc-dot-ring" :d="dotsPath" />
                    <path class="lc-dot lc-dot-gap" :d="dotsPath" />
                    <path class="lc-dot lc-dot-core" :d="dotsPath" />
                    <!-- VREDNOSTI IZNAD TACAKA -->
                    <text
                        v-for="(price, index) in sortedPrices"
                        :key="`value-${price.year}-${price.month}`"
                        class="lc-value"
                        :x="getPointX(index)"
                        :y="plotY(price.average_price) - 16"
                    >{{ formatPrice(price.average_price) }}</text>
                    <!-- X OSA: mesec i godina -->
                    <text
                        v-for="(price, index) in sortedPrices"
                        :key="`label-${price.year}-${price.month}`"
                        class="lc-label"
                        :x="getPointX(index)"
                        :y="labelY"
                    >
                        <tspan class="lc-month">{{ shortMonth(price.month) }}</tspan>
                        <tspan class="lc-year" :x="getPointX(index)" dy="14">{{ price.year }}</tspan>
                    </text>
                    <!-- TOOLTIP (samo dok je pokazivac iznad meseca) -->
                    <g v-if="tip" class="lc-tip">
                        <circle class="lc-hover-dot" :cx="tip.px" :cy="tip.py" r="7" />
                        <path class="lc-tip-bg" :d="tip.arrow" />
                        <rect class="lc-tip-bg" :x="tip.x" :y="tip.y" :width="tipWidth" :height="tipHeight" rx="7" />
                        <text class="lc-tip-value" :x="tip.x + tipWidth / 2" :y="tip.y + 19">{{ tip.value }} din.</text>
                        <text class="lc-tip-date" :x="tip.x + tipWidth / 2" :y="tip.y + 34">{{ tip.date }}</text>
                    </g>
                </svg>
            </div>
        </div>
        <!-- =================================================
            NEMA PODATAKA
        ================================================== -->
        <div
            v-else
            class="chart-empty"
        >
            <i class="bi bi-graph-up chart-empty-icon"></i>
            <div>
                Trenutno nema istorijskih podataka za
                izabrani proizvod i grad.
            </div>
        </div>
        <!-- =================================================
            FOOTER
        ================================================== -->
        <div
            v-if="sortedPrices.length"
            class="chart-footer"
        >
            <div class="chart-source">
                <div>

                </div>
                <div class="mt-1">
                    <strong>
                        Napomena:
                    </strong>
                    Prikazane su prosečne mesečne cene
                    na osnovu dostupnih nedeljnih cena.
                </div>
            </div>
            <div class="chart-last-price">
                <i class="bi bi-calendar3 me-1"></i>
                Poslednji podatak:
                <strong>
                    {{ lastPeriod }}
                </strong>
            </div>
        </div>
    </div>
</template>
<script setup>
const props = defineProps({
    productName: {
        type: String,
        default: ''
    },
    cityName: {
        type: String,
        default: ''
    },
    description: {
        type: String,
        default: ''
    },
    prices: {
        type: Array,
        default: () => []
    },
    indexPage: {
        type: Boolean,
        default: false
    },
    categories: {
        type: Array,
        default: () => []
    }
});
import {
    BContainer,
    BCol,
    BRow
} from "bootstrap-vue-next";

import SectionTitleWithSubTitle from '~/components/cms/product/SectionTitleWithSubTitle.vue'

/*
|--------------------------------------------------------------------------
| Ikonice statistike (SVG putanje glifova iz fonta pijaceicon:
| area-chart, chevron-up, chevron-down, calendar-solid)
|--------------------------------------------------------------------------
*/
const statIcons = {
    average: {
        name: "area-chart",
        w: 1170,
        h: 878,
        d: "M73 805L1170 805L1170 878L0 878L0 0L73 0L73 805ZM731 402L951 220L1097 732L146 732L146 402L402 73L731 402Z"
    },
    max: {
        name: "chevron-up",
        w: 920,
        h: 592,
        d: "M910 487L910 487L815 581Q810 586 803 589Q796 592 789 592Q782 592 775 589L775 589Q769 586 763 581L763 581L460 277L157 581Q151 586 145 589L145 589Q138 592 131 592Q124 592 117 589Q110 586 105 581L105 581L10 487Q5 481 2 474L2 474Q0 468 0 461L0 461Q0 453 2 447L2 447Q5 440 10 435L10 435L434 11Q440 6 446 3L446 3Q453 0 460 0Q467 0 474 3L474 3Q480 6 486 11L486 11L910 435Q915 440 918 447L918 447Q920 453 920 461L920 461Q920 468 918 474L918 474Q915 481 910 487Z"
    },
    min: {
        name: "chevron-down",
        w: 920,
        h: 591,
        d: "M910 157L910 157L486 580Q480 585 474 588L474 588Q467 591 460 591Q453 591 446 588L446 588Q440 585 434 580L434 580L10 157Q5 151 2 145L2 145Q0 138 0 131L0 131Q0 123 2 117L2 117Q5 110 10 105L10 105L105 10Q110 5 117 2L117 2Q124 0 131 0Q138 0 145 2L145 2Q151 5 157 10L157 10L460 314L763 10Q769 5 775 2L775 2Q782 0 789 0Q796 0 803 2L803 2Q810 5 815 10L815 10L910 105Q915 110 918 117L918 117Q920 123 920 131L920 131Q920 138 918 145L918 145Q915 151 910 157Z"
    },
    count: {
        name: "calendar-solid",
        w: 896,
        h: 1024,
        d: "M192 128L192 64Q192 47 201 32L201 32Q209 17 224 9L224 9Q239 0 256 0Q273 0 288 9L288 9Q303 17 311 32L311 32Q320 47 320 64L320 64L320 128L576 128L576 64Q576 47 585 32L585 32Q593 17 608 9L608 9Q623 0 640 0Q657 0 672 9L672 9Q687 17 695 32L695 32Q704 47 704 64L704 64L704 128L800 128Q826 128 848 141Q870 154 883 176Q896 198 896 224L896 224L896 320L0 320L0 224Q0 198 13 176Q26 154 48 141Q70 128 96 128L96 128L192 128ZM0 384L896 384L896 928Q896 954 883 976Q870 998 848 1011Q826 1024 800 1024L800 1024L96 1024Q70 1024 48 1011Q26 998 13 976Q0 954 0 928L0 928L0 384Z"
    }
};
/*
|--------------------------------------------------------------------------
| Sort prices ASC
|--------------------------------------------------------------------------
*/
const sortedPrices = computed(() => {
    return [...props.prices]
        .sort((a, b) => {
            if (
                Number(a.year) !==
                Number(b.year)
            ) {
                return (
                    Number(a.year) -
                    Number(b.year)
                );
            }
            return (
                Number(a.month) -
                Number(b.month)
            );
        });
});
/*
|--------------------------------------------------------------------------
| Price values
|--------------------------------------------------------------------------
*/
const priceValues = computed(() =>
    sortedPrices.value
        .map(
            item =>
                Number(item.average_price)
        )
        .filter(
            value =>
                !Number.isNaN(value)
        )
);
/*
|--------------------------------------------------------------------------
| Max price
|--------------------------------------------------------------------------
*/
const maxPrice = computed(() => {
    if (
        !priceValues.value.length
    ) {
        return 0;
    }
    return Math.max(
        ...priceValues.value
    );
});
/*
|--------------------------------------------------------------------------
| Min price
|--------------------------------------------------------------------------
*/
const minPrice = computed(() => {
    if (
        !priceValues.value.length
    ) {
        return 0;
    }
    return Math.min(
        ...priceValues.value
    );
});
/*
|--------------------------------------------------------------------------
| Average price
|--------------------------------------------------------------------------
*/
// promena (%) poslednje cene u odnosu na isti mesec prethodne godine; null ako nema podataka za poredjenje
const yearChange = computed(() => {
    const list = sortedPrices.value;
    if (!list.length) {
        return null;
    }
    const last = list[list.length - 1];
    const before = list.find(
        item =>
            Number(item.month) === Number(last.month) &&
            Number(item.year) === Number(last.year) - 1
    );
    const from = Number(before?.average_price);
    const to = Number(last.average_price);
    if (!from || Number.isNaN(to)) {
        return null;
    }
    return ((to - from) / from) * 100;
});
// poslednja (najnovija) mesecna cena
const lastPrice = computed(() => {
    const list = sortedPrices.value;
    return list.length ? Number(list[list.length - 1].average_price) : 0;
});
// period na koji se odnosi prosek: prva i poslednja godina u podacima (npr. "2020 – 2026")
const averagePeriod = computed(() => {
    const list = sortedPrices.value;
    if (!list.length) {
        return '';
    }
    const first = list[0].year;
    const last = list[list.length - 1].year;
    return Number(first) === Number(last) ? String(first) : `${first} – ${last}`;
});
const averagePrice = computed(() => {
    if (
        !priceValues.value.length
    ) {
        return 0;
    }
    const sum =
        priceValues.value.reduce(
            (total, value) =>
                total + value,
            0
        );
    return (
        sum /
        priceValues.value.length
    );
});
/*
|--------------------------------------------------------------------------
| Price formatter
|--------------------------------------------------------------------------
*/
const formatPrice = (price) => {
    const value =
        Number(price);
    if (
        Number.isNaN(value)
    ) {
        return '-';
    }
    return value.toLocaleString(
        'sr-RS',
        {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }
    );
};
/*
|--------------------------------------------------------------------------
| Months
|--------------------------------------------------------------------------
*/
const months = [
    '',
    'Januar',
    'Februar',
    'Mart',
    'April',
    'Maj',
    'Jun',
    'Jul',
    'Avgust',
    'Septembar',
    'Oktobar',
    'Novembar',
    'Decembar'
];
const shortMonths = [
    '',
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Maj',
    'Jun',
    'Jul',
    'Avg',
    'Sep',
    'Okt',
    'Nov',
    'Dec'
];
const monthName = (month) =>
    months[
        Number(month)
    ] ?? '';
const shortMonth = (month) =>
    shortMonths[
        Number(month)
    ] ?? '';
/*
|--------------------------------------------------------------------------
| First period
|--------------------------------------------------------------------------
*/
const firstPeriod = computed(() => {
    if (
        !sortedPrices.value.length
    ) {
        return '';
    }
    const item =
        sortedPrices.value[0];
    return `${
        monthName(item.month)
    } ${item.year}`;
});
/*
|--------------------------------------------------------------------------
| Last period
|--------------------------------------------------------------------------
*/
const lastPeriod = computed(() => {
    if (
        !sortedPrices.value.length
    ) {
        return '';
    }
    const item =
        sortedPrices.value[
            sortedPrices.value.length - 1
        ];
    return `${
        monthName(item.month)
    } ${item.year}`;
});
/*
|--------------------------------------------------------------------------
| Max price period
|--------------------------------------------------------------------------
*/
const maxPricePeriod = computed(() => {
    if (
        !sortedPrices.value.length
    ) {
        return '';
    }
    const item =
        sortedPrices.value.find(
            item =>
                Number(
                    item.average_price
                ) ===
                maxPrice.value
        );
    if (!item) {
        return '';
    }
    return `${
        monthName(item.month)
    } ${item.year}`;
});
/*
|--------------------------------------------------------------------------
| Min price period
|--------------------------------------------------------------------------
*/
const minPricePeriod = computed(() => {
    if (
        !sortedPrices.value.length
    ) {
        return '';
    }
    const item =
        sortedPrices.value.find(
            item =>
                Number(
                    item.average_price
                ) ===
                minPrice.value
        );
    if (!item) {
        return '';
    }
    return `${
        monthName(item.month)
    } ${item.year}`;
});
/*
|--------------------------------------------------------------------------
| Line chart settings
|--------------------------------------------------------------------------
*/
const chartHeight = 300;
const pointDistance = 70;
/*
|--------------------------------------------------------------------------
| Chart width
|--------------------------------------------------------------------------
*/
const chartWidth = computed(() => {
    return Math.max(
        (
            sortedPrices.value.length -
            1
        ) * pointDistance + 80,
        600
    );
});
/*
|--------------------------------------------------------------------------
| Chart min
|--------------------------------------------------------------------------
*/
const chartMin = computed(() => {
    if (
        !priceValues.value.length
    ) {
        return 0;
    }
    const min =
        minPrice.value;
    const range =
        maxPrice.value -
        minPrice.value;
    const padding =
        Math.max(
            10,
            range * 0.15
        );
    return Math.max(
        0,
        Math.floor(
            (min - padding) / 10
        ) * 10
    );
});
/*
|--------------------------------------------------------------------------
| Chart max
|--------------------------------------------------------------------------
*/
const chartMax = computed(() => {
    if (
        !priceValues.value.length
    ) {
        return 100;
    }
    const max =
        maxPrice.value;
    const range =
        maxPrice.value -
        minPrice.value;
    const padding =
        Math.max(
            10,
            range * 0.15
        );
    return Math.ceil(
        (max + padding) / 10
    ) * 10;
});
/*
|--------------------------------------------------------------------------
| Y axis values
|--------------------------------------------------------------------------
*/
const yAxisValues = computed(() => {
    const count = 6;
    const difference =
        chartMax.value -
        chartMin.value;
    if (
        difference <= 0
    ) {
        return [
            chartMax.value
        ];
    }
    const step =
        difference /
        (count - 1);
    const values = [];
    for (
        let i = 0;
        i < count;
        i++
    ) {
        values.push(
            Math.round(
                chartMax.value -
                (step * i)
            )
        );
    }
    return values;
});
/*
|--------------------------------------------------------------------------
| X position
|--------------------------------------------------------------------------
*/
const getPointX = (index) => {
    return (
        40 +
        (
            index *
            pointDistance
        )
    );
};
/*
|--------------------------------------------------------------------------
| Y position
|--------------------------------------------------------------------------
*/
const getPointY = (price) => {
    const value =
        Number(price);
    const range =
        chartMax.value -
        chartMin.value;
    if (!range) {
        return (
            chartHeight / 2
        );
    }
    return (
        (
            value -
            chartMin.value
        ) /
        range
    ) * chartHeight;
};
/*
|--------------------------------------------------------------------------
| SVG grafik
|--------------------------------------------------------------------------
*/
const svgHeight = 355;
const labelY = chartHeight + 29;
// y u SVG-u: 0 je gore, a getPointY meri od dna oblasti grafika
const plotY = (price) => chartHeight - getPointY(price);
// y horizontalne linije (poravnato sa vrednostima na Y osi)
const gridY = (index) => {
    const last = yAxisValues.value.length - 1;
    return last > 0 ? (index * chartHeight) / last : 0;
};
const verticalGridPath = computed(() =>
    sortedPrices.value
        .map((_, index) => `M${getPointX(index)} 0V${chartHeight}`)
        .join('')
);
const linePoints = computed(() =>
    sortedPrices.value
        .map((price, index) => `${getPointX(index)},${plotY(price.average_price)}`)
        .join(' ')
);
// tooltip: indeks meseca ispod pokazivaca (null = nema)
const hoverIndex = ref(null);
const tipWidth = 115;
const tipHeight = 44;
const onPointer = (event) => {
    const box = event.currentTarget.getBoundingClientRect();
    const x = (event.clientX - box.left) * (chartWidth.value / box.width);
    const last = sortedPrices.value.length - 1;
    hoverIndex.value = Math.min(last, Math.max(0, Math.round((x - 40) / pointDistance)));
};
const tip = computed(() => {
    const index = hoverIndex.value;
    const price = index === null ? null : sortedPrices.value[index];
    if (!price) return null;
    const px = getPointX(index);
    const py = plotY(price.average_price);
    const x = Math.min(Math.max(px - tipWidth / 2, 0), chartWidth.value - tipWidth);
    const above = py - 64 >= 0;
    const y = above ? py - 64 : py + 20;
    const arrow = above
        ? `M${px - 6} ${y + tipHeight}L${px + 6} ${y + tipHeight}L${px} ${y + tipHeight + 6}Z`
        : `M${px - 6} ${y}L${px + 6} ${y}L${px} ${y - 6}Z`;
    return {
        px, py, x, y, arrow,
        value: formatPrice(price.average_price),
        date: `${monthName(price.month)} ${price.year}`
    };
});
// nulte duzine linija sa okruglim krajem je tacka
const dotsPath = computed(() =>
    sortedPrices.value
        .map((price, index) => `M${getPointX(index)} ${plotY(price.average_price)}h0.01`)
        .join('')
);
</script>
 